import React, { useEffect, useState } from "react";
import { useParams, Redirect } from "react-router-dom";
import RacingStep1 from "./RacingStep1";
import RacingStep2 from "./RacingStep2";
import RacingStep3 from "./RacingStep3";

import { useSelector } from "react-redux";
import Axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import { URL_LIST_ALL } from "../configs/Api";
import AkkhorLayout from "../layout/Akkhor";


export default function FormRacing(props) {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [runFinish, setRunFinish] = useState(false);
    const [step, setStep] = useState(1);
    const [detail, setDetail] = useState(null);
    const [type, setType] = useState(1);

    useEffect(() => {
        if (id > 0) {
            let mounted = true;
            Axios.get(URL_LIST_ALL + "at_exam_tests/" + id, user.config)
                .then(async (res) => {
                    if (res.data.status === "success") {
                        if (mounted) {
                            let _detail = { ...res.data.data };
                            _detail.total_point = _detail.total_point ? _detail.total_point : 10
                            setType(_detail.type)

                            setDetail(_detail);
                        }
                    } else console.log(res.data.message);
                })
                .catch((err) => console.log(err));
            return () => (mounted = false);
        }
    }, [user, id]);

    const addTest = (values) => {
        if (id > 0) {
            Axios.put(URL_LIST_ALL + 'at_exam_tests/' + id, values, user.config).then(res => {
                // console.log(res);
                if (res.data.status === "success") {
                    setRunFinish(true)
                    confirmAlert({
                        title: 'Thành công',
                        message: 'Bạn cập nhật ' + (type === 1 ? ' bài thi Tomo Racing' : 'bài kiểm tra') + ' thành công',
                        buttons: [{ label: 'OK' }]
                    });
                } else {
                    confirmAlert({
                        title: 'Lỗi',
                        message: res.data.message,
                        buttons: [{ label: 'OK' }]
                    });
                }
            }).catch(err => console.log(err));
        } else {
            values.type = type;
            //console.log(values);
            Axios.post(URL_LIST_ALL + 'at_exam_tests', values, user.config).then(res => {
                if (res.data.status === "success") {
                    setRunFinish(true)
                    confirmAlert({
                        title: 'Thành công',
                        message: 'Bạn thêm mới bài thi Tomo Racing thành công',
                        buttons: [{ label: 'OK' }]
                    });
                } else {
                    confirmAlert({
                        title: 'Lỗi',
                        message: res.data.message,
                        buttons: [{ label: 'OK' }]
                    });
                }
            }).catch(err => console.log(err));
        }

    }
    return (
        <AkkhorLayout idrole="list-tomo-racing">
            {runFinish && <Redirect to={"/list-tomo-racing"} />}
            <div className="card height-auto mt-5">
                <div className="card-body ">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>{id > 0 ? "Sửa" : "Tạo"} bài thi Tomo Racing</h3>
                        </div>
                    </div>
                    {step === 1 && <RacingStep1 detail={detail} nextStep={(e) => { setDetail(e); setStep(step + 1); }} />}
                    {(step === 2 && detail) && <RacingStep2 detail={detail} nextStep={(e) => { setDetail(e); setStep(step + 1); }} previewStep={(e) => setStep(step - 1)} />}
                    {(step === 3 && detail) && <RacingStep3 detail={detail} nextStep={addTest} previewStep={(e) => setStep(step - 1)} />}

                </div>
            </div>
        </AkkhorLayout>
    );
}
